/**
 * Formats a price string (from minor units) into a displayable currency format.
 * @param price - The price string in minor units (e.g., "7500").
 * @param currencyMinorUnit - The number of decimal places for the currency (default 2).
 * @returns The formatted price string (e.g., "75.00").
 */
export const formatMinorUnitString = (
  price: string | undefined | null,
  currencyMinorUnit: number = 2 // Default to 2 decimal places
): string => {
  if (!price) return (0).toFixed(currencyMinorUnit);

  const divisor = Math.pow(10, currencyMinorUnit);
  const numericPrice = parseFloat(price) / divisor;

  return isNaN(numericPrice)
    ? (0).toFixed(currencyMinorUnit)
    : numericPrice.toFixed(currencyMinorUnit);
};
